import PropTypes from "prop-types";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import withStyles from "@mui/styles/withStyles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Slot from "../../../00-atoms/Slot/Slot";

/**
 * @module Components/01-molecules
 */

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0,0,0,.125)",
    padding: 0,
    "&:before": {
      display: "none"
    }
  }
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0,0,0,.03)",
    minHeight: 76,
    "&$expanded": {
      minHeight: 76
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    },
    alignItems: "center"
  },
  expanded: {}
})(props => <MuiAccordionSummary {...props} />);

// AccordionSummary.muiName = "AccordionSummary";

const AccordionDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(0)
  }
}))(MuiAccordionDetails);
// className="flex items-center cursor-pointer bg-grey-light hover:bg-grey p-2"
/**
 * The row can be expanded and shrinked. The div marked with data-slot="content" attribute is visible when the row is expanded.
 */
const ExpandableRow = props => {
  return (
    <Accordion
      defaultExpanded={props.shouldBeExpanded}
      onChange={props.onToggle}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        id={`${props.id}-summary`}>
        <div className="flex-1">
          <Slot slot="title">{props.children}</Slot>
        </div>
        <Slot slot="info">{props.children}</Slot>
      </AccordionSummary>
      <AccordionDetails>
        {props.isToggledOpen || props.shouldBeExpanded ? (
          <Slot slot="content">{props.children}</Slot>
        ) : null}
      </AccordionDetails>
    </Accordion>
  );
};

ExpandableRow.defaultProps = {
  shouldBeExpanded: false
};

ExpandableRow.propTypes = {
  children: PropTypes.array,
  id: PropTypes.string,
  onToggle: PropTypes.func,
  isToggledOpen: PropTypes.bool,
  /**
   * Shrinking and expanding works via this property.
   */
  shouldBeExpanded: PropTypes.bool
};

export default ExpandableRow;
